import Twemoji from 'react-twemoji'; 
import './Slidecontent.css';

export const renderHorizontalBarChart = (
    obj,
    title,
    subtitle = '',
    sortDesc = false,
    labelFn
  ) => {
    if (!obj || Object.keys(obj).length === 0) {
      return (
        <div className="slide-content scrollable">
          <h2>{title}</h2>
          <p>No data found.</p>
        </div>
      );
    }
  
    let entries = Object.entries(obj).map(([k, v]) => [k, parseInt(v, 10)]);
  
    if (sortDesc) {
      // Sort by count descending
      entries.sort((a, b) => b[1] - a[1]);
    } else {
      // Sort by key ascending
      entries.sort((a, b) => a[0].localeCompare(b[0]));
    }
  
    // Calculate total for percentage
    const total = entries.reduce((sum, [, count]) => sum + count, 0);
  
    return (
      <div className="slide-content scrollable">
        <h2>{title}</h2>
        {subtitle && <h3 className="chart-subtitle">{subtitle}</h3>}
  
        <div className="flex-chart-container">
          {entries.map(([key, count]) => {
            const label = labelFn ? labelFn(key, count) : `${key} (${count})`;
            const percent = total > 0 ? ((count / total) * 100).toFixed(1) : 0;
  
            return (
              <div className="chart-row" key={key}>
                <div className="chart-label">{label}</div>
                <div className="chart-bar-container">
                  <div
                    className="chart-bar"
                    style={{ width: `${percent}%` }}
                  >
                    <span className="chart-bar-text">{percent}%</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };
  
/**
 * 2) Bar chart for hashtags WITHOUT percentages
 */
export const renderHashtagBarChart = (obj, title, sortDesc = false) => {
    if (!obj || Object.keys(obj).length === 0) {
        return (
        <div className="slide-content scrollable">
            <h2>{title}</h2>
            <p>No hashtag data found.</p>
        </div>
        );
    }

    let entries = Object.entries(obj).map(([k, v]) => [k, parseInt(v, 10)]);
    if (sortDesc) {
        entries.sort((a, b) => b[1] - a[1]);
    } else {
        entries.sort((a, b) => a[0].localeCompare(b[0]));
    }

    const maxCount = Math.max(...entries.map(([, count]) => count));

    return (
        <div className="slide-content">
        <h2>{title}</h2>
        <div className="flex-chart-container">
            {entries.map(([hashtag, count]) => {
            const ratio = maxCount > 0 ? (count / maxCount) * 100 : 0;
            return (
                <div className="chart-row" key={hashtag}>
                <div className="chart-label">{hashtag}</div>
                <div className="chart-bar-container">
                    <div
                    className="chart-bar"
                    style={{ width: `${ratio}%` }}
                    >
                    <span className="chart-bar-text">{count}</span>
                    </div>
                </div>
                </div>
            );
            })}
        </div>
        </div>
    );
};

/**
 * 3) NEW: "Emoji Graph" made of repeated emojis
 *    - We repeat the emoji up to a max width
 *    - Sort descending by count
 *    - Display raw count next to the repeated emojis
 */
export const renderEmojiBarChartNoPercent = (emojiObj, title) => {
    if (!emojiObj || Object.keys(emojiObj).length === 0) {
      return (
        <div className="slide-content">
          <h2>{title}</h2>
          <p>No emoji data found.</p>
        </div>
      );
    }

    // Convert { "🤞": "39", "❤️": "20" } => [["🤞", 39], ["❤️", 20], ...]
    let entries = Object.entries(emojiObj).map(([emo, strCount]) => [
      emo,
      parseInt(strCount, 10),
    ]);

    // Sort from greatest to least
    entries.sort((a, b) => b[1] - a[1]);

    // Compute max for bar widths
    const maxCount = Math.max(...entries.map(([, count]) => count));

    return (
      <div className="slide-content">
        <h2>{title}</h2>
        <div className="flex-chart-container">
          {entries.map(([emoji, count]) => {
            const ratio = maxCount > 0 ? (count / maxCount) * 100 : 0;
            return (
              <div className="chart-row" key={emoji}>
                <div className="chart-label">
                  {/* 2) Wrap the emoji in <Twemoji> so it renders as Twemoji images */}
                  <Twemoji options={{ className: 'twemoji' }}>{emoji}</Twemoji>
                </div>
                <div className="chart-bar-container">
                  <div
                    className="chart-bar"
                    style={{ width: `${ratio}%` }}
                  >
                    <span className="chart-bar-text">{count}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };